import { orders } from './orders'
import { orderState } from './order-state'
import { inquiries } from './inquiry'
import { entity } from './entity'
import { common } from './common'
import { customer } from './customer'
import { modelFinder } from './model-finder'
import { productFinder } from './product-finder'
import { users } from './users'
import { multiplier } from './multiplier'
import { modelviewer } from './model-viewer'
import { tree } from './tree'
import { salesReps } from './sales-reps'
import { configurableMaterial } from './configurable-material'
export function getModules() {
  return {
    orders,
    'order-state': orderState,
    users,
    inquiries,
    entity,
    common,
    customer,
    'product-finder': productFinder,
    'model-finder': modelFinder,
    multiplier,
    'model-viewer': modelviewer,
    tree,
    'sales-reps': salesReps,
    'configurable-material': configurableMaterial,
  }
}

export function getPersistModules() {
  return ['orders']
}
